import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/Table';
import { clientsTable as TEXT } from 'locales/en/client';
import ClientActions from './ClientActions';

const ClientTable = ({ data, ...rest }) => {
  const [activeItem, setActiveItem] = useState(null);
  const toggleActiveItem = (id) => {
    if (activeItem === id) {
      setActiveItem(null);
    } else {
      setActiveItem(id);
    }
  };

  return (
    <Table
      titles={[
        TEXT.name,
        TEXT.integration,
        TEXT.company,
        TEXT.defaultRole,
        TEXT.defaultFeeStructure,
        '',
      ]}
      hasData={!!data.length}
      gridClassName="grid-5-cols"
      {...rest}
    >
      {data.map((item, idx) => {
        const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;
        return (
          <Fragment key={item.id}>
            <span
              data-index-number={dataIndexNumber}
              className="py-3 px-5 text-xs text-javelin-gray-dark"
            >
              {item.name}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className={`py-3 px-5 text-xs text-javelin-gray-dark ${
                item.integration !== '-' ? 'underline' : ''
              }`}
            >
              {item.integration}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className={`py-3 px-5 text-xs text-javelin-gray-dark ${
                item.company !== '-' ? 'underline' : ''
              }`}
            >
              {item.company}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className={`py-3 px-5 text-xs text-javelin-gray-dark ${
                item.defaultRole !== '-' ? 'underline' : ''
              }`}
            >
              {item.defaultRole}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className={`py-3 px-5 text-xs text-javelin-gray-dark ${
                item.defaultFeeStructure !== '-' ? 'underline' : ''
              }`}
            >
              {item.defaultFeeStructure}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className="relative py-3 pr-5 text-right text-xs text-javelin-gray-dark"
            >
              <ClientActions
                client={item}
                onClickOpen={() => toggleActiveItem(item.id)}
                isOpen={activeItem === item.id}
                onClose={() => setActiveItem(null)}
                position={idx <= data.length - 4 ? 'bottom' : 'top'}
              />
            </span>
          </Fragment>
        );
      })}
    </Table>
  );
};

ClientTable.propTypes = {
  data: PropTypes.array,
};
ClientTable.defaultProps = {
  data: [],
};
export default ClientTable;
